import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import debounce from '../../node_modules/lodash-es/debounce.js';

const MAX_UNAUTHORIZED_ERRORS = 4;
const ERROR_WINDOW_MS = 1e4;
function useAuthErrorHandler(client, logout) {
  useClientLayoutEffect(() => {
    let unauthorizedCount = 0;
    let firstErrorTimestamp = null;
    const resetCounter = debounce(() => {
      unauthorizedCount = 0;
      firstErrorTimestamp = null;
    }, ERROR_WINDOW_MS);
    const onUnauthorized = () => {
      const now = Date.now();
      if (!firstErrorTimestamp) {
        firstErrorTimestamp = now;
      }
      unauthorizedCount++;
      if (unauthorizedCount >= MAX_UNAUTHORIZED_ERRORS && now - firstErrorTimestamp < ERROR_WINDOW_MS) {
        logout();
        resetCounter.cancel();
      } else {
        resetCounter();
      }
    };
    client.on("unauthorized", onUnauthorized);
    return () => {
      client.off("unauthorized", onUnauthorized);
      resetCounter.cancel();
    };
  }, [
    client,
    logout
  ]);
}

export { useAuthErrorHandler };
//# sourceMappingURL=useAuthErrorHandler.js.map
